import React from "react";
import Icon from "components/AppIcon";
import Image from "components/AppImage";
import Button from "components/ui/Button";

export default function ProductCard({ product, onAddToCart, cartQuantity }) {
  const isOutOfStock = product?.stock === 0;
  const isLowStock = product?.stock > 0 && product?.stock <= 10;

  return (
    <div className="card p-0 overflow-hidden flex flex-col hover:shadow-md transition-shadow duration-200">
      <div className="relative h-36 md:h-40 overflow-hidden bg-muted">
        <Image
          src={product?.image}
          alt={product?.imageAlt}
          className="w-full h-full object-cover"
        />
        {product?.promoPrice && (
          <span className="absolute top-2 left-2 bg-warning text-warning-foreground text-xs font-caption font-medium px-2 py-0.5 rounded">
            PROMO
          </span>
        )}
        {isOutOfStock && (
          <div className="absolute inset-0 bg-foreground/50 flex items-center justify-center">
            <span className="text-white font-caption font-medium text-sm">Out of Stock</span>
          </div>
        )}
        {cartQuantity > 0 && (
          <span className="absolute top-2 right-2 bg-primary text-primary-foreground text-xs font-data font-medium w-6 h-6 rounded-full flex items-center justify-center">
            {cartQuantity}
          </span>
        )}
      </div>
      <div className="p-3 flex flex-col flex-1">
        <p className="font-caption text-xs text-muted-foreground mb-0.5">{product?.category}</p>
        <h4 className="font-heading font-semibold text-sm text-foreground line-clamp-2 mb-1 flex-1">{product?.name}</h4>
        <p className="font-caption text-xs text-muted-foreground mb-2">{product?.sku}</p>
        <div className="flex items-center gap-2 mb-2">
          {product?.promoPrice ? (
            <>
              <span className="font-data font-semibold text-sm text-warning">₱{product?.promoPrice?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</span>
              <span className="font-data text-xs text-muted-foreground line-through">₱{product?.price?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</span>
            </>
          ) : (
            <span className="font-data font-semibold text-sm text-foreground">₱{product?.price?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</span>
          )}
        </div>
        <div className="flex items-center justify-between mb-3">
          <span className={`font-caption text-xs flex items-center gap-1 ${isOutOfStock ? "text-destructive" : isLowStock ? "text-warning" : "text-success"}`}>
            <Icon name={isOutOfStock ? "XCircle" : isLowStock ? "AlertTriangle" : "CheckCircle"} size={12} color="currentColor" strokeWidth={2} />
            {isOutOfStock ? "Out of Stock" : isLowStock ? `Low: ${product?.stock} left` : `${product?.stock} in stock`}
          </span>
          <span className="font-caption text-xs text-muted-foreground">{product?.unit}</span>
        </div>
        <Button
          variant={isOutOfStock ? "outline" : "default"}
          size="sm"
          fullWidth
          disabled={isOutOfStock}
          iconName="Plus"
          iconPosition="left"
          iconSize={14}
          onClick={() => !isOutOfStock && onAddToCart(product)}
        >
          {isOutOfStock ? "Unavailable" : "Add to Cart"}
        </Button>
      </div>
    </div>
  );
}